import { render } from "./data.vue?vue&type=template&id=07f1479f&scoped=true"
import script from "./data.vue?vue&type=script&lang=js"
export * from "./data.vue?vue&type=script&lang=js"

import "./data.vue?vue&type=style&index=0&id=07f1479f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tap-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f1479f"]])

export default __exports__